
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
  @Prop({ default: 1 }) active!: number;
}
